// extracted by mini-css-extract-plugin
export default {"Main":"Avatar_Main__n393q","background":"Avatar_background__zogqW","selected":"Avatar_selected__6Aa6N","Big":"Avatar_Big__9bIoZ"};